const headerDataDetail = [
    {
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 260
      },
      {
        prop: 'InvName',
        label: '存货名称',
        columnwidth: 260
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 260
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 260
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 260
      },
      {
        prop: 'VouDCode',
        label: '来源单据表体编号',
        columnwidth: 270
      },
      {
        prop: 'TaxUnitPrice',
        label: '原币含税单价',
        columnwidth: 450
      },
      {
        prop: 'TaxRate',
        label: '税率',
        columnwidth: 450
      },
      {
        prop: 'ExchangeRate',
        label: '汇率',
        columnwidth: 450
      },
      {
        prop: 'UnitPrice',
        label: '原币单价',
        columnwidth: 450
      },
      {
        prop: 'UnitPrice',
        label: '原币单价',
        columnwidth: 450
      },
      {
        prop: 'Sum',
        label: '原币价税合计',
        columnwidth: 450
      },
      {
        prop: 'Money',
        label: '原币金额',
        columnwidth: 450
      },
      {
        prop: 'TaxPrice',
        label: '原来税额',
        columnwidth: 450
      },
      {
        prop: 'NatSum',
        label: '本币价税合计',
        columnwidth: 450
      },
      {
        prop: 'NatMoney',
        label: '本币金额',
        columnwidth: 450
      },
      {
        prop: 'NatTaxPrice',
        label: '本币税额',
        columnwidth: 450
      },
      {
        prop: 'InvoiceNo',
        label: '发票号',
        columnwidth: 450
      },
      {
        prop: 'BillQuantity',
        label: '开票数量',
        columnwidth: 450
      },
]
export default headerDataDetail